import { render, staticRenderFns } from "./MitActionNewPersonPage.vue?vue&type=template&id=3696826f&scoped=true"
import script from "./MitActionNewPersonPage.vue?vue&type=script&lang=js"
export * from "./MitActionNewPersonPage.vue?vue&type=script&lang=js"
import style0 from "./MitActionNewPersonPage.vue?vue&type=style&index=0&id=3696826f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3696826f",
  null
  
)

export default component.exports